/**
 * JSON utility functions
 * Safe parsing and handling of JSON data
 */

/**
 * Safely parse JSON string, returns empty object on error
 * @param {string} value - JSON string to parse
 * @param {any} fallback - Fallback value if parsing fails (default: {})
 * @returns {any} Parsed JSON or fallback value
 */
export const safelyParseJSON = (value, fallback = {}) => {
  try {
    return JSON.parse(value || '{}');
  } catch (err) {
    console.warn('Failed to parse JSON:', err);
    return fallback;
  }
};

/**
 * Safely stringify JSON, returns empty string on error
 * @param {any} value - Value to stringify
 * @param {number} indent - Indentation spaces (default: 2)
 * @returns {string} JSON string or empty string on error
 */
export const safelyStringifyJSON = (value, indent = 2) => {
  try {
    return JSON.stringify(value, null, indent);
  } catch (err) {
    console.warn('Failed to stringify JSON:', err);
    return '';
  }
};
